export default __webpack_public_path__ + "static/retreat_5-4a97fa41368cb224a7cc53cb21fd29ee.jpg";